import { request } from '../../helpers/api/request';

export const deleteSearchSettings = async (id: number) => {
    const { data } = await request({
        url: `admin/search/often-searched/${id}`,
        method: 'DELETE',
    });

    return data;
};
